// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3uKyM","emails":"CreateEditClinics_emails__3R8X9","emailTagLabel":"CreateEditClinics_emailTagLabel__tZNQY"};